import PublishACalendarSection from './PublishACalendarSection';
import { observer } from 'mobx-react';
import * as React from 'react';

/**
 * Wrapper component for rendering the calendar sharing settings UI.
 */
export default observer(function PublishedCalendarsFull() {
    return (
        <div>
            <PublishACalendarSection />
        </div>
    );
});
